import React from 'react'
import { ReactComponent as Logo } from '../../images/showit-logo.svg';

const LogoComponent = ({ handleClick, customClass }) => {

    const handleClickBound = () => {
        console.log('handleClick');

        if (handleClick) {
            handleClick();
        }
    }

    return (
        <div className={'logo-content-wrapper'}
            onClick={handleClickBound}>
            <Logo className={`logo-icon ${customClass ? customClass : ''}`} />
        </div>
    )
}

export default LogoComponent;